module.exports = __webpack_public_path__ + "static/img/wechat_QR.667db29a.jpg";